import React, { useEffect, useRef, useState } from "react";
import DialogWrap, { DialogWrapLogin } from "../../controls/components/dialogWrap/DialogWrap";
import FomrmLogin from "./component/FormLogin";

export default function DialogLogin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	setIsDialogOpenCreate: (value: boolean) => void;
	setIsDialogOpenForgot: (value: boolean) => void;
}) {
	return (
		<DialogWrapLogin
			login={true}
			hideFooter={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Log in or Sign up">
			<FomrmLogin
				setOpenDialog={props.setOpenDialog}
				setIsDialogOpenCreate={props.setIsDialogOpenCreate}
				setIsDialogOpenForgot={props.setIsDialogOpenForgot}
			/>
		</DialogWrapLogin>
	);
}
